import React from 'react';
import { useNavigate } from 'react-router-dom';

const MobileRestriction = ({ feature, onClose }) => {
  const navigate = useNavigate();
  
  const getRestrictionInfo = () => {
    switch (feature) {
      case 'game_launch':
        return {
          title: 'Desktop Required for Game Launching',
          message: 'Game launching requires a desktop computer to control the main display for your audience.',
          icon: '💻',
          suggestions: [
            'Use a laptop or desktop computer to launch games',
            'You can still create and manage games on mobile',
            'All other features work great on mobile!'
          ],
          cta: 'Got it!'
        };
        
      case 'live_scoring':
        return {
          title: 'Desktop Required for Live Scoring',
          message: 'Live game scoring requires a desktop computer for the best experience.',
          icon: '📊',
          suggestions: [
            'Use a desktop computer for live game management',
            'You can view game results on mobile',
            'Game creation and editing work on mobile'
          ],
          cta: 'Understood'
        };
        
      case 'audience_display':
        return {
          title: 'Desktop Required for Display Control',
          message: 'Audience display control requires a desktop computer.',
          icon: '🖥️',
          suggestions: [
            'Use a desktop computer to control the main display',
            'The audience display will work on a separate screen',
            'You can still manage games on mobile'
          ],
          cta: 'Got it!'
        };
        
      default:
        return {
          title: 'Desktop Required',
          message: 'This feature requires a desktop computer.',
          icon: '💻',
          suggestions: ['Use a laptop or desktop computer'],
          cta: 'OK'
        };
    }
  };
  
  const info = getRestrictionInfo();
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="text-center">
          <div className="text-4xl mb-4">{info.icon}</div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">{info.title}</h3>
          <p className="text-gray-600 mb-4">{info.message}</p>
          
          <div className="text-left mb-6">
            <ul className="space-y-2">
              {info.suggestions.map((suggestion, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span className="text-sm text-gray-600">{suggestion}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300 transition-colors"
            >
              {info.cta}
            </button>
            <button
              onClick={() => navigate('/helpdesk')}
              className="flex-1 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
            >
              Get Help
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileRestriction;


